import React from "react";
import styled from "styled-components";
import Components from "../../components";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";

const { AuthForm, Width } = Components;

const COMPANY_NAME = "Freedom Broker Global Markets Ltd";

const FirstBlock = styled.div`
  width: 100%;
  padding: 80px 0;
  border-bottom: 1px solid #d1d3d4;

  & > div {
    display: flex;
  }
`;

const BTitile = styled.div`
  white-space: pre-line;
  font-weight: 500;
  font-size: 32px;
  line-height: 110%;
`;

const Content = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(250px, 1fr));
  gap: 40px;
  margin-inline-start: 30px;
`;

const ContentIn = styled.div`
  display: flex;
  align-items: self-start;
`;

const NoticeLayout = styled.div`
  display: flex;
  width: 100%;
  gap: 28px;
  align-items: flex-start;
`;

const NoticeTitle = styled(BTitile)`
  flex: 0 0 150px;
`;

const NoticeContent = styled.div`
  flex: 1;
  display: grid;
  grid-template-columns: repeat(2, minmax(280px, 1fr));
  gap: 28px 40px;

  & > *:last-child {
    grid-column: 1;
  }

  @media (max-width: 1200px) {
    gap: 28px 32px;
  }

  @media (max-width: 900px) {
    grid-template-columns: 1fr;

    & > *:last-child {
      grid-column: auto;
    }
  }
`;

const WelcomeAePage = () => {
  const { t } = useTranslation();
  const metaTitle = t("welcome.ae.metaTitle", {
    defaultValue: t("welcome.metaTitle"),
  });
  const loginTitle = t("welcome.ae.loginTitle", {
    defaultValue: t("welcome.loginTitle"),
  });
  const noticeText = t("welcome.ae.newCabinetNoticePartner", {
    company: COMPANY_NAME,
    defaultValue: t("welcome.newCabinetNoticePartner", {
      company: COMPANY_NAME,
    }),
  });
  const partnersTitle = t("welcome.ae.partnersTitle", {
    defaultValue: t("welcome.partnersTitle"),
  });

  return (
    <>
      <Helmet>
        <title>{metaTitle} - AE</title>
        <meta name="description" content={`${metaTitle} AE`} />
      </Helmet>

      <FirstBlock>
        <Width>
          <BTitile>{loginTitle}</BTitile>
          <Content>
            <ContentIn>
              <AuthForm />
            </ContentIn>
            <ContentIn>{noticeText}</ContentIn>
          </Content>
        </Width>
      </FirstBlock>

      <FirstBlock>
        <Width>
          <NoticeLayout>
            <NoticeTitle>{partnersTitle}</NoticeTitle>
            <NoticeContent>
              <ContentIn>{t("welcome.passwordWarning")}</ContentIn>
              <ContentIn>{t("welcome.emailAccessWarning")}</ContentIn>
              <ContentIn>{t("welcome.fraudWarning")}</ContentIn>
            </NoticeContent>
          </NoticeLayout>
        </Width>
      </FirstBlock>

      <FirstBlock>
        <Width>
          <BTitile>{t("welcome.documents")}</BTitile>
        </Width>
      </FirstBlock>
    </>
  );
};

export default WelcomeAePage;
